import Link from 'next/link'

const Footer = () => {
  const menusFooter = [
    { id: '1', label: 'Home', link: '/', target: '_self' },
    { id: '2', label: 'Pricing', link: '/pricing', target: '_self' },
    { id: '3', label: 'Help', link: 'https://discord.com/invite/aNJQPKRm', target: '_blank' },
    { id: '4', label: 'Privacy Policy', link: '/privacy', target: '_self' },
    { id: '5', label: 'Terms Of Service', link: '/terms-and-conditions', target: '_self' },
  ]

  return (
    <footer className="relative border-t border-gray-200/50 dark:border-gray-700/50 bg-gradient-to-r from-slate-50 via-white to-slate-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 backdrop-blur-sm">
      <div className=" inset-0 bg-gradient-to-r from-blue-50/20 via-transparent to-purple-50/20 dark:from-blue-900/10 dark:via-transparent dark:to-purple-900/10"></div>
      <div className="container mx-auto px-6 py-6 relative">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <nav className="flex-1">
            <ul className="flex flex-wrap gap-8">
              {menusFooter.map((item) => (
                <li key={item.id}>
                  <Link
                    href={item.link}
                    target={item.target}
                    rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                    className="group text-sm font-semibold text-gray-700   dark:text-gray-300 dark:hover:text-transparent  transition-all duration-300 relative"
                  >
                    <span className="relative z-10">{item.label}</span>
                    <span className="absolute inset-x-0 -bottom-1 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out rounded-full"></span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="flex items-center space-x-6 text-sm font-medium">
            <span className="text-gray-600 dark:text-gray-400">
              © {new Date().getFullYear()}{' '}
              <span className="font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                Styley
              </span>
              , Inc.
            </span>
            <span className="hidden sm:block text-gray-300 dark:text-gray-600">•</span>
            <span className="flex items-center gap-1 text-gray-600 dark:text-gray-400">
              Built with <span className="text-red-500 animate-pulse text-base">❤️</span> by{' '}
              <span className="font-semibold text-gray-800 dark:text-gray-200">Styley Team</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
